function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#222",
  d: "M11.0702576,3.00000044 C10.3895771,4.17669391 10,5.54285187 10,7.00000044 C10,7.69059958 10.087506,8.3607606 10.252035,9.00000044 L9,9.00000044 L9,3.00000044 L11.0702576,3.00000044 Z M10.581517,10.0000004 C11.3932819,12.0053993 12.9946011,13.6067186 15,14.4184834 L15,16.0000004 L9,16.0000004 L9,10.0000004 L10.581517,10.0000004 Z M22,13.9297429 L22,16.0000004 L16,16.0000004 L16,14.7479655 C16.6392398,14.9124944 17.3094009,15.0000004 18,15.0000004 C19.4571486,15.0000004 20.8233065,14.6104233 22,13.9297429 Z M2,3.00000044 L8,3.00000044 L8,9.00000044 L2,9.00000044 L2,3.00000044 Z M2,10.0000004 L8,10.0000004 L8,16.0000004 L2,16.0000004 L2,10.0000004 Z M2,17.0000004 L8,17.0000004 L8,23.0000004 L2,23.0000004 L2,17.0000004 Z M9,17.0000004 L15,17.0000004 L15,23.0000004 L9,23.0000004 L9,17.0000004 Z M16,17.0000004 L22,17.0000004 L22,23.0000004 L16,23.0000004 L16,17.0000004 Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 7,
  r: 6,
  fill: "#A9DDA8"
}));

var SvgLauncherAlert = function SvgLauncherAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLauncherAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LauncherAlert.2f905af0.svg";
export { ForwardRef as ReactComponent };